import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealDispositionsService } from './deal-dispositions.service';
import Project from 'src/app/interfaces/project';
import { Subscription, pairwise } from 'rxjs';
import Participant from 'src/app/interfaces/participant';
import Permission from 'src/app/interfaces/permission';

type DealInfoField = {
  name: string;
  value?: any;
};
type DealInfoColumn = DealInfoField[];
@Component({
    selector: 'deal-dispositions',
    templateUrl: './deal-dispositions.component.html',
    styleUrls: ['./deal-dispositions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealDispositionsComponent {
  public projectId: string | null = null;
  public project: Project | null = null;
  public readOnly = true;
  public topDealInfo: DealInfoColumn[] = [
    [
      {
        name: 'Location',
      },
      {
        name: 'Total Units',
      },
      {
        name: 'Risk Rating',
      },
    ],
    [
      {
        name: 'Disposition Associate',
      },
      {
        name: 'Originator',
      },
      {
        name: 'Asset Manager',
      },
    ],
    [
      {
        name: 'Dispositions Legal Firm',
      },
      {
        name: 'Dispositions Legal Contact',
      },
    ],
    [
      {
        name: 'General Partner',
      },
      {
        name: 'Sponsor',
      },
      {
        name: 'Co-Sponsor'
      }
    ],
  ];
  constructor(
    public route: ActivatedRoute,
    public dealDispositionService: DealDispositionsService
  ) {}
  public projectSub: Subscription;
  ngOnInit() {
    this.projectId = this.route.snapshot.paramMap.get('id');
    if (this.projectId)
      this.dealDispositionService.getDealDisposition(this.projectId);
    this.projectSub = this.dealDispositionService.$project.subscribe(
      (project: Project) => {
        this.project = project;
        this.formatData();
      }
    );
  }
  formatData() {
    for (let i = 0; i < this.topDealInfo.length; i++) {
      let column = this.topDealInfo[i];
      for (let j = 0; j < column.length; j++) {
        let field = column[j];
        field.value = this.getFieldData(field.name);
      }
    }
  }
  parseLocation(): string | null {
    let value = null;
    if (this.project?.properties && this.project?.properties.length > 0) {
      let property = this.project.properties[0];
      if (
        property.entity.entityAddresses &&
        property.entity.entityAddresses.length > 0
      ) {
        let entityAddress = property.entity.entityAddresses[0];
        value = `${entityAddress.address.zipCode.city}, `;
        value += entityAddress.address.zipCode.state.abbreviation;
      }
    }
    return value;
  }
  parseTotalUnits(): string | null {
    let value = null;
    let total = 0;
    if (this.project?.properties) {
      for (let i = 0; i < this.project.properties.length; i++) {
        total += this.project.properties[i].total_units;
      }
    }
    if (total > 0) {
      value = `${total}`;
    }
    return value;
  }
  getParticipant(field: string): any {
    let value = null;
    if (this.project?.participants) {
      let participant = this.project.participants.find(
        (participant: Participant) => participant.role.name === field
      );
      if (participant?.organization) {
        value = participant.organization;
      } else if (participant?.person) {
        value = participant.person;
      } else if (participant?.sponsor) {
        value = participant.sponsor;
      }
    }

    return value;
  }

  getCosponsors(){
    let value:any = [];
    if(this.project?.participants){
      let cosponsors = this.project.participants.filter((participant: Participant) => participant.role.name == 'Co-Sponsor')
      if(cosponsors.length > 0){
        cosponsors.forEach((sponsor) => {
          value.push(sponsor.sponsor)
        })
      }
    }
    return value;
  }
  getFieldData(field: string): string | null {
    let value = null;
    switch (field) {
      case 'Location':
        value = this.parseLocation();
        break;
      case 'Total Units':
        value = this.parseTotalUnits();
        break;
      case 'Risk Rating':
        value = this.project?.projectDetail?.risk_rating ?? null;
        break;
      case 'Co-Sponsor':
        value = this.getCosponsors()
        break;
      default:
        value = this.getParticipant(field);
    }
    return value;
  }
  createDisposition() {
    if (this.projectId) {
      this.dealDispositionService.createDisposition(this.projectId);
    }
  }
  ngOnDestroy() {
    this.projectSub?.unsubscribe();
  }
}
